__turbopack_context__.v({
  "buttonContainer": "BlogArticlesGrid-module-scss-module__qbHLfa__buttonContainer",
  "cardLinkGrid": "BlogArticlesGrid-module-scss-module__qbHLfa__cardLinkGrid",
  "container": "BlogArticlesGrid-module-scss-module__qbHLfa__container",
  "heading": "BlogArticlesGrid-module-scss-module__qbHLfa__heading",
});
